export default {
  zoneOne: { top: "53%", left: "13%" },
  zoneTwo: { top: "38.2%", left: "15.57%" },
  zoneThree: { top: "36.2%", left: "35.24%" },
  zoneFour: { top: "57%", left: "42.65%" },
  zoneFive: { top: "49.25%", left: "58.23%" },
  zoneSix: { top: "41%", left: "88.6%" },
  zoneSeven: { top: "46%", left: "92.5%" },
  zoneEight: { top: "46.5%", left: "33.45%" },
  zoneNine: { top: "34%", left: "53%" },
  zoneTen: { top: "31.2%", left: "64.9%" },
  zoneEleven: { top: "66%", left: "28%" },
  zoneTwelve: { top: "39%", left: "77%" }
};
